<app-error [title]="title" [description]="detail" [isFullPage]="true"></app-error>